import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/lebenslauf-ausbildung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')